import Head from 'next/head';
//#region [Props]
type JulekalenderSeoProps = {
};
//#endregion

//#region [Component]
export default function PåskekalenderSeo({ }: JulekalenderSeoProps) {
	return <Head>
		<meta key="ogTitle" property="og:title" content="Påskekonkurransen 2024" />

		<meta key="ogDescription" name="og:description" content="Filmwebs Påskekonkurranse 2024 i samarbeid med Outland." />
		<meta key="metaDescription" name="description" content="Filmwebs Påskekonkurranse 2024 i samarbeid med Outland." />
		<meta key="metaTitle" name="title" content="Påskekonkurransen 2024 - Filmweb" />

		<title key="title">Påskekonkurransen 2024 - Filmweb</title>
	</Head>;
}
//#endregion

//#region [Styles]

//#endregion